<template>
  <div>
    <section class="hero is-primary">
      <div class="container">
        <nav
          class="breadcrumb is-small"
          aria-label="breadcrumbs"
        >
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'playlists' }">
                Playlists
              </router-link>
            </li>
            <li class="is-active">
              <a
                href="#"
                aria-current="page"
              >
                {{ playlist ? playlist.name : "" }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <section class="section">
      <div
        v-if="playlist"
        class="container"
      >
        <playlist-edit
          v-if="editMode"
          :initial-playlist="playlist"
          :initial-playlist-items="playlistItems"
          @update="updatePlaylistElement($event)"
        />
        <playlist-show v-else />
        <a
          v-if="editMode"
          class="button is-info"
          @click="deleteThisPlaylist()"
        >
          <span>Delete</span>
        </a>
      </div>
    </section>
    <a
      class="add button is-large is-warning"
      @click="toggleEdit()"
    >
      <span class="icon is-medium">
        <i
          v-if="editMode"
          class="fas fa-check"
        />
        <i
          v-else
          class="fas fa-pencil-alt"
        />
      </span>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PlaylistEdit from "../components/PlaylistEdit";
import PlaylistShow from "../components/PlaylistShow";

export default {
  components: {
    PlaylistEdit,
    PlaylistShow
  },
  data() {
    return {
      editMode: this.$route.query.edit
    };
  },
  computed: {
    ...mapGetters({
      playlist: "selectedPlaylist",
      playlistItems: "playlistItems"
    })
  },
  created() {
    const playlistId = this.$route.params.playlistId;
    this.refreshPlaylistItems();
    this.fetchPlaylist(playlistId);
    this.fetchPlaylistItems(playlistId);
  },
  methods: {
    deleteThisPlaylist() {
      if (confirm("Do you really want to delete?")) {
        this.deletePlaylist({ id: this.$route.params.playlistId }).then(() => {
          this.$router.push("/playlists");
        });
      }
    },
    setupQuery() {
      const query = {};
      if (this.editMode) query.edit = this.editMode;
      this.$router.replace({ query });
    },
    toggleEdit() {
      if (this.editMode) this.savePlaylist();
      this.editMode = !this.editMode;
      this.setupQuery();
    },
    ...mapActions([
      "fetchPlaylistItems",
      "fetchPlaylist",
      "deletePlaylist",
      "savePlaylist",
      "updatePlaylistElement",
      "refreshPlaylistItems"
    ])
  }
};
</script>

<style lang="scss">
.edit {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// Playlist.vue?0e5b8e4c